import React, { createContext, useMemo, useState } from 'react'
import { useVODStore } from '@/shared/store'
import { shallow } from 'zustand/shallow'

interface IVodContentContext {
    triggerScrollHandler: ({
        isScroll,
        amount,
        type,
    }: {
        isScroll: boolean
        amount: number
        type: 'increase' | 'decrease'
    }) => void
    triggerScroll: { isScroll: boolean; counter: number }
    currentVodPageId: string
}

export const VodContentContext = createContext<IVodContentContext | undefined>(
    undefined
)

export const VodContentProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const { vodPages } = useVODStore(
        (state) => ({
            vodPages: state.vodPages,
        }),
        shallow
    )

    const [triggerScroll, setTriggerScroll] = useState({
        isScroll: false,
        counter: 0,
    })
    const triggerScrollHandler = ({
        isScroll,
        amount,
        type,
    }: {
        isScroll: boolean
        amount: number
        type: 'increase' | 'decrease'
    }) => {
        setTriggerScroll((prev) => ({
            isScroll,
            counter:
                type === 'increase'
                    ? prev.counter + amount
                    : prev.counter - amount,
        }))
    }

    return (
        <VodContentContext.Provider
            value={useMemo(
                () => ({
                    triggerScrollHandler,
                    triggerScroll,
                    currentVodPageId: vodPages[vodPages.length - 1]?.itemId,
                }),
                [triggerScroll, vodPages.length]
            )}>
            {children}
        </VodContentContext.Provider>
    )
}
